import React from 'react';
import Skeleton from 'react-loading-skeleton';

const UserRoleSkelton = ({header = [], rows=5}) => {
    return (
        <>
                <table className="table table-striped table-bordered">
                    <thead>
                        <tr>  {header.map(e =>  <th> {e.title}</th> )} </tr>
                    </thead>
                    <tbody>
                        {[...Array(rows)].map((_, index) => (
                            <tr key={index}> {header.map(e =>  <td> <Skeleton width="120px" height="2rem" /> </td> )} </tr>
                        ))}
                    </tbody>
                </table>
        </>
    );
};

export default UserRoleSkelton;